<template>
<div>
  <div id="mapCommentHeader">
  <b-button v-b-tooltip title="Fermer" @click="showOrHideMapCommentSideBar()" variant="light" class="closeButton">
    <img src="../../../assets/logos/close_black.png" alt="close" class="img-fluid"/> 
  </b-button> 
  <h5> Commentaire pour la carte {{getMapByIndex(index).mapTitle}} </h5>
  </div>
  <b-card tag="article" class="mb-2" v-if="mapCommentsList.length > 0">
    <b-card v-if="!showEditorComment" no-body class="mb-1" v-for="(mapComment, mapCommentIndex) in mapCommentsList" :key="mapCommentIndex">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle="'comment' + mapCommentIndex"> Commentaire de {{mapComment.user.username}} </b-button>
      </b-card-header>
      <b-collapse :id="'comment' + mapCommentIndex" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <div v-html="mapComment.mapComment"> {{mapComment.mapComment}}</div>
          <b-button v-if="currentUser.username == mapComment.user.username" variant="success" @click="showOrHideEditorComment(mapComment)">Éditer</b-button>
          <b-button v-if="currentUser.username == mapComment.user.username" variant="danger" @click="deleteMapComment(mapComment.mapCommentId)">Supprimer</b-button>
        </b-card-body>
      </b-collapse>
    </b-card>
    <div id="editorComment" v-if="showEditorComment">
      <editor-comment v-bind:commentToEdit="mapCommentToEdit.mapComment" v-on:showOrHideEditorComment="showOrHideEditorComment()" v-on:addComment="addMapComment"></editor-comment>
    </div>
  </b-card>
  <h6> Aucun commentaire sur la carte {{getMapByIndex(index).mapTitle}} </h6>
  <b-button v-if="isAuthenticated && !showEditorComment" variant="success" @click="showOrHideEditorComment()">Créer commentaire</b-button>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import EditorComment from '../EditorComment'
import EventBus from '@components/bus/bus.js';

export default {
  name: 'MapCommentConsultation',
  components: { EditorComment },
  data() {
    return {
      showEditorComment: false,
      mapCommentToEdit: '',
      test: [],
      newMapComment: {
        'author': '',
        'mapId': '',
        'mapComment': ''
      }
    }
  },
  created() {
    this.$store.dispatch('getMapCommentsList', this.getMapByIndex(this.index).mapId)
  },
  computed: {
    ...mapGetters({
      index: 'getIndex',
      getMapByIndex: 'getMapByIndex',
      mapCommentsList: 'getMapCommentsList',
      currentUser: 'getCurrentUser',
      isAuthenticated: 'getIsAuthenticated'
    })
  },
  methods: {
    // Envoie l'évènement permettant de fermer la barre latérale de commentaire de carte
    showOrHideMapCommentSideBar: function() {
      EventBus.$emit('showOrHideMapCommentSideBar')
    },
    // Fonction qui permet d'ajouter ou éditer un commentaire de carte
    addMapComment: function(comment) {
      this.newMapComment.author = this.currentUser.username
      this.newMapComment.mapId = this.getMapByIndex(this.index).mapId
      this.newMapComment.mapComment = comment
      // Si édition d'un commentaire
      if (this.mapCommentToEdit) {
        this.$store.dispatch('deleteMapComment', this.mapCommentToEdit.mapCommentId).
        then(response => {
          this.$store.dispatch('addMapComment', this.newMapComment)
        }).then(response => {
          this.showOrHideMapCommentSideBar()
        })
        // Si nouvelle création
      } else {
        this.$store.dispatch('addMapComment', this.newMapComment)
        this.showOrHideMapCommentSideBar()
      }
    },
    // Suppression d'un commentaire de carte
    deleteMapComment: function(mapCommentId) {
      this.$store.dispatch('deleteMapComment', mapCommentId)
      this.showOrHideMapCommentSideBar()
    },
    // Affiche l'éditeur de commentaire
    showOrHideEditorComment: function(mapCommentToEdit) {
      if (mapCommentToEdit) {
        this.mapCommentToEdit = mapCommentToEdit
      }
      this.showEditorComment = !this.showEditorComment
    }
  }
}
</script>
<style>
#mapCommentHeader {
  margin-bottom: 5%;
}
.closeButton {
    float: right;
    margin-bottom: 5%;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/sideBarMapComment/MapCommentConsultation.vue